import { useMemo } from 'react';
import { isPriceDiscoveryOneTimeEligible } from '@/enterprise/components/OfferBuilder/utils';
import useTakerMarkets, { TakerMarket } from '@/enterprise/data/useTakerMarkets';

/**
 * Filters all taker markets down to those eligible for the acquisition one-time price discovery flow.
 * A market is eligible when:
 * 1. It has a one-time price-discovery offer option available
 * 2. It has a next clear time scheduled
 * 3. It has eligible invoices to offer on (excludes taker-excluded invoices)
 * 4. The market is enabled
 * 5. The market is not manually awarded
 * 6. There is no currently enabled offer
 */
const useAcquisitionTakerMarkets = (): TakerMarket[] => {
  const { data: takerMarkets } = useTakerMarkets();

  return useMemo(() => {
    if (!takerMarkets) {
      return [];
    }

    return takerMarkets.filter(
      (takerMarket) =>
        isPriceDiscoveryOneTimeEligible([takerMarket]) &&
        takerMarket.eligibleInvoiceAmount > 0 &&
        takerMarket.marketIsEnabled &&
        !takerMarket.offerConfig.isManuallyAwarded &&
        !takerMarket.offerConfig.isActiveExpressAccept &&
        !takerMarket.offerConfig.isEnabled
    );
  }, [takerMarkets]);
};

export default useAcquisitionTakerMarkets;
